import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

class Firebase {
  auth;
  analytics;

  constructor() {
    firebase.initializeApp(config);
    this.analytics = firebase.analytics();
    this.auth = firebase.auth();
  }

  currentUser = () => this.auth.currentUser;

  signInWithEmailAndPassword = (email, password) => {
    return this.auth.signInWithEmailAndPassword(email, password);
  };

  signOut = () => this.auth.signOut();
}

const firebaseService = new Firebase();

export default firebaseService;

export const AuthPersistence = firebase.auth.Auth.Persistence;
